import { ArrowUpRight } from "lucide-react";
import { useLang, UI } from "@/i18n/lang";
import { CATEGORIES } from "@/content/site";
import { LocaleLink as Link } from "@/i18n/routes";

export default function ProjectCard({ project, aspect = "aspect-[4/3]", index = 0 }) {
  const { t } = useLang();
  const cat = CATEGORIES.find((c) => c.id === project.category);
  return (
    <Link
      to={`/work/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group block"
    >
      <div className={`relative w-full overflow-hidden bg-secondary ${aspect}`}>
        <img
          src={project.image}
          alt={project.title}
          loading={index < 2 ? "eager" : "lazy"}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-paper/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-bronze flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
          <ArrowUpRight size={16} className="text-paper" />
        </div>
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-2xl md:text-3xl leading-tight text-ink group-hover:text-bronze transition-colors duration-300">
            {project.title}
          </h3>
          <p className="mt-1.5 text-sm text-stone">{t(project.short)}</p>
        </div>
        <div className="text-right shrink-0 pt-1">
          <span className="font-mono text-[11px] uppercase tracking-widest text-bronze block">
            {cat ? t(cat.label) : ""}
          </span>
          <span className="font-mono text-[11px] text-stone/60">{project.year}</span>
        </div>
      </div>
      <p className="mt-2 font-mono text-[11px] uppercase tracking-widest text-stone/70">
        {t(UI.caseStudy.built)} · {t(project.role)}
      </p>
    </Link>
  );
}
